import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { Icon } from '@unite-us/ui';
function IconButton(props) {
  var className = props.className,
    disabled = props.disabled,
    icon = props.icon,
    id = props.id,
    labelText = props.labelText,
    onClick = props.onClick;
  return /*#__PURE__*/React.createElement("button", {
    "aria-label": labelText,
    "aria-haspopup": "dialog",
    className: cx(className, disabled && 'pointer-events-none opacity-50', 'flex justify-center items-center space-x-2 cursor-pointer'),
    id: id,
    onClick: onClick,
    type: "button",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: icon,
    className: "fill-current text-current-blue",
    size: 16
  }), /*#__PURE__*/React.createElement("p", {
    className: "normal-case text-current-blue whitespace-no-wrap"
  }, labelText));
}
IconButton.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};
IconButton.defaultProps = {
  className: '',
  disabled: false
};
export default IconButton;
//# sourceMappingURL=IconButton.js.map